<mat-horizontal-stepper #stepper>
  <mat-step [stepControl]="firstFormGroup">
    <ng-template matStepLabel>Seleziona i dati principali</ng-template>
    <mat-card>
      <mat-card-content>
        <form [formGroup]="firstFormGroup">

          <div class="toggle-container">
            <mat-slide-toggle
              *ngFor="let formName of namesOfFirstStep"
              [color]="'primary'"
              [formControlName]="formName">
              {{getSliderNameFirstStep(formName)}}
            </mat-slide-toggle>
          </div>

        </form>
      </mat-card-content>
      <mat-card-actions>
        <button mat-button mat-raised-button color="warn" matStepperPrevious>Back</button>
        <button mat-button mat-raised-button matStepperNext>Next</button>
      </mat-card-actions>
    </mat-card>

  </mat-step>
  <mat-step [stepControl]="secondFormGroup">
    <ng-template matStepLabel>Seleziona i dati secondari</ng-template>
    <mat-card>
      <mat-card-content>
        <form [formGroup]="secondFormGroup">
          <div class="toggle-container">
            <mat-slide-toggle
              *ngFor="let formName of namesOfSecondStep"
              [color]="'primary'"
              [formControlName]="formName">
              {{getSliderNameSecondStep(formName)}}
            </mat-slide-toggle>
          </div>

        </form>
      </mat-card-content>
      <mat-card-actions>
        <button mat-button mat-raised-button color="warn" matStepperPrevious>Back</button>
        <button mat-button mat-raised-button matStepperNext>Next</button>
      </mat-card-actions>
    </mat-card>

  </mat-step>
  <mat-step>
    <ng-template matStepLabel>Seleziona il template di stampa</ng-template>
    <mat-card>

      <mat-card-content>
        <div class="objects-loading-container" *ngIf="loading">
          <ngx-spinner
            [fullScreen]="false"
            name="loading-objects"
            type="square-loader"
            size="medium"
            class="loading-spinner">
          </ngx-spinner>
        </div>

        <div style="text-align:center;" *ngIf="!loading">

          <mat-form-field appearance="fill" style="width:40%;">
            <mat-label>Seleziona il modello di stampa</mat-label>
            <mat-select matNativeControl required [(value)]="selectedModel">
              <mat-option value="model_showroom">Stampa per mostre</mat-option>
              <mat-option value="model_archive">Stampa per archivio</mat-option>
            </mat-select>
          </mat-form-field>

        </div>

        <div id="preview-container" [class.show]="showPreview">
          <!-- @TODO duplicate textareas in ng-template with ngmodel
          ngif depending on model to print
          https://stackoverflow.com/questions/36026428/angular2-show-placeholder-image-if-img-src-is-not-valid
          https://angular.io/guide/image-directive
          -->
          <div *ngIf="selectedModel==='model_showroom'" class="preview model_showroom">

            <div class="a4-page" *ngFor="let apage of printListForShowRoom">
              <div class="object-row three" *ngFor="let dataToPrint of apage">
                <div class="img-container" [style.background-image]="'url(' +dataToPrint.previewUrl + ')'">
                  <!--                <img alt='missing' [src]="dataToPrint.previewUrl">-->
                </div>
                <div class="text-container">
                  <div *ngFor="let entry of dataToPrint.printArray">
                    {{entry[0]}}: <span
                    *ngIf="euroToPrint(entry)">&euro;</span> {{entry[1]}}
                  </div>
                </div>
              </div>
            </div>

          </div>

          <div *ngIf="selectedModel==='model_archive'" class="preview model_archive">
            <div class="archive-object-container" *ngFor="let dataToPrint of printListForArchive">
              <div class="a4-page">
                <div class="object-row three">
                  <div class="img-container"
                       [style.background-image]="'url(' +dataToPrint.previewUrl + ')'"></div>
                  <div class="text-container">
                    <div *ngFor="let entry of dataToPrint.printArray">
                      {{entry[0]}}: {{entry[1]}}
                    </div>
                  </div>
                </div>

                <div class="fornitore" *ngIf="dataToPrint.obj.fornitore && secondToPrintMap.fornitore">
                  <span class="h-title-small">Fornitore</span>
                  <p>nome: {{dataToPrint.obj.fornitore.nome}}</p>
                  <p>cognome: {{dataToPrint.obj.fornitore.cognome}}</p>
                  <p>CF: {{dataToPrint.obj.fornitore.codiceFiscale}}</p>
                  <p>piva: {{dataToPrint.obj.fornitore.partitaIva}}</p>
                  <p>ragione sociale: {{dataToPrint.obj.fornitore.ragioneSociale}}</p>
                  <p>contatti: {{dataToPrint.obj.fornitore.contatti.join('-')}}</p>
                </div>
              </div>

              <div class="pages-container"
                   *ngIf="dataToPrint.obj.attachmentsGrouped?.length && secondToPrintMap.allegati">
                <div class="a4-page" *ngFor="let mediaList of dataToPrint.obj.attachmentsGrouped">
                  <span class="h-title-small">Allegati</span>
                  <div class="secondary-items-list">
                    <div class="attachment-print" *ngFor="let media of mediaList" [style.height]="secondaryItemHeight">
                      <div class="img-container"
                           [style.background-image]="'url(' + fileUrl + media.previewUrl + ')'">
                      </div>
                      <div class="text-container">
                        <p>nome: {{media.name}}</p>
                        <p>tipo: {{media.type}}</p>
                        <p>note: {{media.note}}</p>
                        <p>tags: {{media.tags?.join(' ')}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pages-container" *ngIf="dataToPrint.obj.fontiBibGrouped?.length && secondToPrintMap.fontiBib">
                <div class="a4-page" *ngFor="let fontiList of dataToPrint.obj.fontiBibGrouped">
                  <span class="h-title-small">Fonti bibliografiche</span>
                  <div class="secondary-items-list">
                    <div class="attachment-print" *ngFor="let fonte of fontiList"
                         [style.height]="secondaryItemEvenHeight">
                      <div class="img-container"
                           [style.background-image]="'url('+fonte.immagine+')'">
                      </div>
                      <div class="text-container">
                        <p>codice unico: {{fonte.codiceUnico}}</p>
                        <p>titolo: {{fonte.titolo}} </p>
                        <p>autore: {{fonte.autore.join('-')}}</p>
                        <p>riferimento: {{fonte.riferimento}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pages-container"
                   *ngIf="dataToPrint.obj.fontiArcGrouped?.length && secondToPrintMap.fontiArch">
                <div class="a4-page" *ngFor="let fontiList of dataToPrint.obj.fontiArcGrouped">
                  <span class="h-title-small">Fonti archivistiche</span>
                  <div class="secondary-items-list">
                    <div class="attachment-print" *ngFor="let fonte of fontiList"
                         [style.height]="secondaryItemEvenHeight">
                      <div class="img-container"
                           [style.background-image]="'url(' + fileUrl + fonte.immagine + ')'">
                      </div>
                      <div class="text-container">
                        <p>codice unico: {{fonte.descrizione}}</p>
                        <p>titolo: {{fonte.titolo}} </p>
                        <p>tipo: {{fonte.tipo}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="pages-container" *ngIf="dataToPrint.obj.movimenti?.length && secondToPrintMap.movimenti">
                <div class="a4-page" *ngFor="let movimentiList of dataToPrint.obj.movimentiGrouped">
                  <span class="h-title-small">Movimenti</span>
                  <div class="secondary-items-list wrapped">
                    <div class="fonte-print" *ngFor="let movimento of movimentiList">
                      <p>Data rientro: {{movimento.dataRientro}}</p>
                      <p>descrizione: {{movimento.descrizione}}</p>
                      <p>Scopo: {{movimento.scopo}}</p>
                      <p>Data uscita: {{movimento.dataUscita}}</p>
                    </div>
                  </div>
                </div>
              </div>


              <div class="pages-container" *ngIf="dataToPrint.obj.ISR?.length && secondToPrintMap.ISR">
                <div class="a4-page" *ngFor="let iscrizioniList of dataToPrint.obj.iscrizioniGrouped">
                  <span class="h-title-small">Iscrizioni</span>
                  <div class="secondary-items-list wrapped">
                    <div class="fonte-print" *ngFor="let isr of iscrizioniList">
                      <p>Classe: {{isr.ISRC}}</p>
                      <p>Tecnica: {{isr.ISRS}}</p>
                      <p>Posizione: {{isr.ISRP}}</p>
                      <p>Trascrizione: {{isr.ISRI}}</p>
                    </div>
                  </div>
                </div>
              </div>


            </div>

          </div>

          <div class="buttons-container" *ngIf="showPreview">
            <button class="close-preview" mat-button mat-raised-button color='accent' (click)="closePreview()">X
            </button>
            <button class="print-preview" mat-button mat-raised-button color='primary' (click)="printMainContent()">
              stampa
            </button>
          </div>

        </div>

      </mat-card-content>

      <mat-card-actions>
        <button mat-button mat-raised-button color="warn" (click)="closeDialog()">Close</button>
        <button mat-button mat-raised-button color="warn" matStepperPrevious>Back</button>
        <button mat-button mat-raised-button color='primary' (click)="loadAndPrintMainContent()">Stampa</button>
        <button mat-button mat-raised-button color='accent' (click)="handlePrintClick()">Preview</button>
      </mat-card-actions>
    </mat-card>

  </mat-step>
</mat-horizontal-stepper>

<ng-template #printme>
  <div *ngIf="selectedModel==='model_showroom'" class="preview model_showroom">
    <div class="a4-page" *ngFor="let apage of printListForShowRoom">
      <div class="object-row three" *ngFor="let dataToPrint of apage">
        <div class="img-container" [style.background-image]="'url(' +dataToPrint.previewUrl + ')'">
        </div>
        <div class="text-container">
          <div *ngFor="let entry of dataToPrint.printArray">
            {{entry[0]}}: <span
            *ngIf="euroToPrint(entry)">&euro;</span> {{entry[1]}}
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="selectedModel==='model_archive'" class="preview model_archive">
    <div class="archive-object-container" *ngFor="let dataToPrint of printListForArchive">
      <div class="a4-page">
        <div class="object-row three">
          <div class="img-container"
               [style.background-image]="'url(' +dataToPrint.previewUrl + ')'"></div>
          <div class="text-container">
            <div *ngFor="let entry of dataToPrint.printArray">
              {{entry[0]}}: {{entry[1]}}
            </div>
          </div>
        </div>

        <div class="fornitore" *ngIf="dataToPrint.obj.fornitore && secondToPrintMap.fornitore">
          <span class="h-title-small">Fornitore</span>
          <p>nome: {{dataToPrint.obj.fornitore.nome}}</p>
          <p>cognome: {{dataToPrint.obj.fornitore.cognome}}</p>
          <p>CF: {{dataToPrint.obj.fornitore.codiceFiscale}}</p>
          <p>piva: {{dataToPrint.obj.fornitore.partitaIva}}</p>
          <p>ragione sociale: {{dataToPrint.obj.fornitore.ragioneSociale}}</p>
          <p>contatti: {{dataToPrint.obj.fornitore.contatti.join('-')}}</p>
        </div>
      </div>

      <div class="pages-container"
           *ngIf="dataToPrint.obj.attachmentsGrouped?.length && secondToPrintMap.allegati">
        <div class="a4-page" *ngFor="let mediaList of dataToPrint.obj.attachmentsGrouped">
          <span class="h-title-small">Allegati</span>
          <div class="secondary-items-list">
            <div class="attachment-print" *ngFor="let media of mediaList" [style.height]="secondaryItemHeight">
              <div class="img-container"
                   [style.background-image]="'url(' + fileUrl + media.previewUrl + ')'">
              </div>
              <div class="text-container">
                <p>nome: {{media.name}}</p>
                <p>tipo: {{media.type}}</p>
                <p>note: {{media.note}}</p>
                <p>tags: {{media.tags?.join(' ')}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pages-container" *ngIf="dataToPrint.obj.fontiBibGrouped?.length && secondToPrintMap.fontiBib">
        <div class="a4-page" *ngFor="let fontiList of dataToPrint.obj.fontiBibGrouped">
          <span class="h-title-small">Fonti bibliografiche</span>
          <div class="secondary-items-list">
            <div class="attachment-print" *ngFor="let fonte of fontiList"
                 [style.height]="secondaryItemEvenHeight">
              <div class="img-container"
                   [style.background-image]="'url('+fonte.immagine+')'">
              </div>
              <div class="text-container">
                <p>codice unico: {{fonte.codiceUnico}}</p>
                <p>titolo: {{fonte.titolo}} </p>
                <p>autore: {{fonte.autore.join('-')}}</p>
                <p>riferimento: {{fonte.riferimento}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pages-container"
           *ngIf="dataToPrint.obj.fontiArcGrouped?.length && secondToPrintMap.fontiArch">
        <div class="a4-page" *ngFor="let fontiList of dataToPrint.obj.fontiArcGrouped">
          <span class="h-title-small">Fonti archivistiche</span>
          <div class="secondary-items-list">
            <div class="attachment-print" *ngFor="let fonte of fontiList"
                 [style.height]="secondaryItemEvenHeight">
              <div class="img-container"
                   [style.background-image]="'url(' + fileUrl + fonte.immagine + ')'">
              </div>
              <div class="text-container">
                <p>codice unico: {{fonte.descrizione}}</p>
                <p>titolo: {{fonte.titolo}} </p>
                <p>tipo: {{fonte.tipo}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="pages-container" *ngIf="dataToPrint.obj.movimenti?.length && secondToPrintMap.movimenti">
        <div class="a4-page" *ngFor="let movimentiList of dataToPrint.obj.movimentiGrouped">
          <span class="h-title-small">Movimenti</span>
          <div class="secondary-items-list wrapped">
            <div class="fonte-print" *ngFor="let movimento of movimentiList">
              <p>Data rientro: {{movimento.dataRientro}}</p>
              <p>descrizione: {{movimento.descrizione}}</p>
              <p>Scopo: {{movimento.scopo}}</p>
              <p>Data uscita: {{movimento.dataUscita}}</p>
            </div>
          </div>
        </div>
      </div>


      <div class="pages-container" *ngIf="dataToPrint.obj.ISR?.length && secondToPrintMap.ISR">
        <div class="a4-page" *ngFor="let iscrizioniList of dataToPrint.obj.iscrizioniGrouped">
          <span class="h-title-small">Iscrizioni</span>
          <div class="secondary-items-list wrapped">
            <div class="fonte-print" *ngFor="let isr of iscrizioniList">
              <p>Classe: {{isr.ISRC}}</p>
              <p>Tecnica: {{isr.ISRS}}</p>
              <p>Posizione: {{isr.ISRP}}</p>
              <p>Trascrizione: {{isr.ISRI}}</p>
            </div>
          </div>
        </div>
      </div>


    </div>

  </div>

</ng-template>

<iframe id="print-frame" #iframe></iframe>
